import { takeLatest, call, put, all } from 'redux-saga/effects';
import api from '~/services/api';
import {
  getComunicadoCodigoTelaSuccess,
} from './actions';

import * as types from './types';

export function* getComunicado({ payload }) {
  try {
    const { codigoTela } = payload;

    console.log(codigoTela);

    const response = yield call(api.get, `system-notice/${codigoTela}`);

    const {
      tituloMensagem,
      corpoMensagem,
      severidade,
      dataCadastro,
      dataInicioVigencia,
      dataExpiracao,
      lgMensagemAtiva,
    } = response.data;

    const dataPayload = {
      tituloMensagem,
      corpoMensagem,
      severidade,
      codigoTela,
      dataCadastro,
      dataInicioVigencia,
      dataExpiracao,
      lgMensagemAtiva,
    };

    yield put(getComunicadoCodigoTelaSuccess(dataPayload));

  } catch (err) {
    console.log('Nenhum comunicado retornado :>> ', err); 
  }
}

export default all([
  takeLatest(types.GET_COMUNICADO_CODIGO_TELA_REQUEST, getComunicado),
]);
